import { TaskStatus } from "./TaskStatus";

export const TaskStatusUpperCompleted = TaskStatus.Completed.toUpperCase();
export const TaskStatusUpperNotStarted = TaskStatus.NotStarted.toUpperCase();
export const TaskStatusUpperInProgress = TaskStatus.InProgress.toUpperCase();
export const TaskStatusUpperOnHold = TaskStatus.OnHold.toUpperCase();
export const TaskStatusUpperDeferred = TaskStatus.Deferred.toUpperCase();
export const TaskStatusUpperEscalated = TaskStatus.Escalated.toUpperCase();
